import React from 'react';

import { useIntl } from 'react-intl-next';

import Button, { type ButtonProps } from '@atlaskit/button/new';

import { messages } from '../../../../../messages';

interface OwnProps {
	nextButtonText: string | undefined;
	nextButtonOnClick: () => void;
	nextButtonAppearance: ButtonProps['appearance'] | undefined;
	isNextButtonDisabled: boolean | undefined;
	isSubmissionLoading: boolean | undefined;
	testId: string;
}

export const NextButton = ({
	nextButtonOnClick,
	nextButtonAppearance,
	isNextButtonDisabled,
	isSubmissionLoading,
	nextButtonText,
	testId,
}: OwnProps) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			testId={`${testId}-footer-next-button`}
			onClick={nextButtonOnClick}
			appearance={nextButtonAppearance || 'primary'}
			type="button"
			isDisabled={isNextButtonDisabled || isSubmissionLoading}
			isLoading={isSubmissionLoading}
		>
			{nextButtonText || formatMessage(messages.defaultNextButtonText)}
		</Button>
	);
};
